export default __webpack_public_path__ + "static/media/Moderat-Extended-Bold.e385ad6b.ttf";